import { createMobileRuntimeGates } from "@libs/environment-client-contracts/mobile";

// The app's own capabilities only (libs/environment-client-contracts/src/mobile):
// its bundle carries none of the other services' definitions.
export const capabilities = createMobileRuntimeGates({
  ...process.env,
  // Mobile uses EXPO_PUBLIC_ namespaces for bundled values; the registry
  // only validates LISSEN_ENV directly.
  LISSEN_ENV: process.env.EXPO_PUBLIC_LISSEN_ENV,
});
